/** API route map: URLS.Controller.Client */
export const Client = {
      Name: 'Client/',
      AddClient: 'add-client',
      UpdateClient: 'update-client',
      GetAll: 'clients',
      PatchClientOnboardingStatusId: 'patch-client-onboarding-status',
      Tiles: 'tiles',
      SearchClientsByName: 'search-client-by-name',
      UpdateProfilePicture: 'update-client-profile-image',
      GetClientLogs: 'get-client-logs',
      GetClientInfo: 'client-info',
      GetClientInfoEnrollment: 'client-info-enrollment',
      GetClientInfoEnrollmentEmployee: 'client-info-enrollment-employee',
      GetClientInfoChequeEnrollment: 'client-info-cheque-enrollment',
      GetAllClientsBoardView: 'clients-board-view',
      AddBillingAddressAsPrimary: 'primaryaddress-as-billing-addres',
      ClientPaycodeClone: 'client-paycodes-clone',
      CloneClientPaycode: 'clone-client-paycodes',
      ClientDeductionCodeClone: 'client-deductioncodes-clone',
      CloneClientDeductionCode: 'clone-client-deductioncodes',
      AddDateForClient: 'add-date-for-client',
      UpdateDateForClient: 'update-date-for-client',
      DeleteW2Form: 'delete-w2-form',
      GetAllEmployees: 'get-all-employees',
      GetServiceTypes: 'get-service-type',
      AddOnboardingClient: 'add-client-onboarding',
      GetGeoCode: 'get-geo-code',
      DeleteClient: 'delete-client',
      GeClientsByMainClientId: 'get-clients-by-main-client',
      AddStaffingClient: 'add-staffing-client',
      UpdateStaffingClient: 'update-staffing-client',
      GetClientInfoForInvoice: 'client-info-for-invoice',
      ClientDetailsEmail: 'client-info-email',
      CheckW2GenerationYear: 'check-w2-generation-year',
      AddW2GenerationYear: 'add-w2-generation-year',
      AddW2CGenerationYear: 'add-w2c-generation-year',
      AddW2BulkGenerationYear: 'add-w2-bulk-generation-year',
      DeleteW2GenerationDate: 'delete-w2-generation-date',
      DeleteW2CGenerationDate: 'delete-w2c-generation-date',
      GetAllSalesPersons: 'get-all-salespersons',
      GetSignedClients: 'get-signed-clients',
      GetClientSelectedInvoiceTemplate: 'get-client-selected-invoice-template',
      UpdateSelectedInvoiceTemplate: 'update-selected-invoice-template',
      UpdateSelectedStaffingInvoiceTemplate: 'update-selected-staffing-invoice-template',
      GetClientName: 'client-name',
      getEmploymentTypeForClientEligibility: 'get-employment-type-for-client-eligibility',
      GetMainClientDropdown: 'get-main-client-dropdown',
      GetClientEmployeeTerminated: 'get-client-employee-terminated',
      ClientEmployeeRehired: 'client-employee-rehired',
      GetClientIdsByNames: 'get-client-ids-by-names',
      SearchClientsForStaffing: 'search-client-for-staffing',
      ActiveEmployees: 'get-all-active-employees',
      ActiveEmployeesKeyPipeline: 'get-all-active-employees-key-pipeline',
      ActiveChildClients: 'get-all-child-client',
      InactiveEmployeeAndClient: 'client-employee-inactive',
      GetGuestSubClients: 'get-guest-subclients',

      GetW2EmployeesPreview: 'get-w2-preview-employees',
      GetW2CEmployeesPreview: 'get-w2c-preview-employees',
      IsMainClientOnboarded: 'is-main-configured',
      GetClientPayrollWcClassCode: 'client-payroll-wc-class-codes',
      GetSelectedGroupsClients: 'get-selected-groups-clients-and-employees',
      GetClientServiceBillingTemplates: 'get-client-service-billing-templates',
      GetMainClientByCompanyId: 'get-main-client-by-company-id',
      GetThirdPartyClients: 'third-party-clients',
      GetClientApporvers: 'get-client-approvers',
      GetSubClientsAndEmployees: 'get-sub-clients-and-employees',
      GetAllActiveEmployeeUsers: 'get-all-active-employee-users',
};
